import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ENV_CONFIG } from '@core/config/environment.token';
import { apiPath, withCurrentCsrf } from './api-request-policy';

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(ENV_CONFIG);
  const document = inject(DOCUMENT);
  return next(
    apiPath(req.url, env.api.baseUrl, document.baseURI) === null
      ? req
      : withCurrentCsrf(req, document)
  );
};
